import EditPatient from './EditPatient'

export default EditPatient
